var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.3999 5.54963c-.7656.34-1.588.5688-2.4512.672.8816-.528 1.5576-1.364 1.876-2.3608-.824.4888-1.7376.844-2.7104 1.036-.7784-.8296-1.8872-1.348-3.1144-1.348-2.3568 0-4.2672 1.9112-4.2672 4.2672 0 .3344.0384.6608.1104.972-3.54638-.1776-6.69038-1.8768-8.79598-4.4592-.3664.6304-.5768 1.3632-.5768 2.1464 0 1.48.7528 2.7864 1.8976 3.55117-.6992-.0224-1.3576-.21437-1.9328-.53357v.0536c0 2.06797 1.4704 3.79277 3.4232 4.18397-.3576.0976-.7352.1496-1.1248.1496-.2744 0-.5424-.0272-.8024-.076.5432 1.6952 2.1192 2.9296 3.9864 2.964-1.46 1.1448-3.3 1.8272-5.3 1.8272-.344 0-.684-.02-1.0184-.06 1.8888 1.2104 4.1312 1.9168 6.5416 1.9168 7.84958 0 12.14078-6.5024 12.14078-12.14157 0-.1848-.004-.3688-.012-.552.8344-.6024 1.5584-1.3536 2.1304-2.2088z",
    fill: "#737373"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.a493400df65f3bc9e728bcbe3ed07176.svg";
export { ForwardRef as ReactComponent };